import {Avatar, message} from 'antd'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext, useRef, useState} from 'react'
import {NullAsDefault, renderIf,} from 'views/Shared'
import {renderIfElse} from "../../../Shared";
import {FaAddressCard, FaUserGraduate} from "react-icons/fa6";
import {MdOutlineEmail, MdOutlinePhone} from "react-icons/md";
import {renderMetadataMissing} from "../../../../components/DynamicFields/functions/renderMetadataMissing";
import copyToClipboard from "copy-to-clipboard";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {IoCopyOutline} from "react-icons/io5";
import {QRComponent} from "../../../AppLocals/custom/QRComponent";
import {GoDotFill} from "react-icons/go";
import {captureImage} from "../../../AppLocals/WoG/functions/captureImage";
import useTranslate from "../../../../modules/local/useTranslate";
import {PiDownloadFill} from "react-icons/pi";
import {renderFromToDate} from "../../../../helpers/datetimeHelpers";
import {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import getAliasName from "../../../../helpers/getAliasName";

const GROUP_COLORS = [
    '#3b82f6', '#10b981', '#8b5cf6', '#f59e0b',
    '#ef4444', '#06b6d4', '#ec4899', '#6366f1',
    '#84cc16', '#f97316', '#14b8a6', '#a855f7'
]

// export - dùng chung để tô màu theo tên (tổ/nhóm học viên, khung phân loại môn học...) ở nhiều nơi,
// tránh mỗi chỗ tự viết lại 1 bảng màu/hash riêng.
export const getGroupColor = (name) => {
    if (!name) return '#9ca3af'
    const num = parseInt(name.replace(/\D/g, '')) || (name.charCodeAt(0) || 0)
    return GROUP_COLORS[num % GROUP_COLORS.length]
}

export const getNameInitial = (fullname) => {
    if (!fullname) return '?'
    const words = fullname.trim().split(/\s+/)
    return (words[words.length - 1]?.charAt(0) || '?').toUpperCase()
}

const WrapperClassStudent = ({item, index, renderContextMenu = NullAsDefault, handleAction = NullAsDefault, children}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [showSensitive, setShowSensitive] = useState(false)

    const {student} = item ?? {}
    const is_admin = !!item?.course_class?.edit

    const {
        avatar,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        fullname,
    } = student ?? {}

    return (
        <div
            key={index}
            className="p-3 flex gap-3 custom-item-render transition-all duration-300 relative list-item">
            <Avatar
                size={36}
                src={avatar || user?.avatar}
                icon={<FaUserGraduate size={16} className="text-color-500"/>}
                className="mt-0.5 flex flex-center background-200 flex-shrink-0"
            />
            <div className="flex flex-col flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 pr-6">
                    <span className="font-bold text-sm text-color-000 leading-snug">
                        {student?.patron_saint_name && (
                            <span className="mr-1 font-medium text-gray-600">
                                {getAliasName(student, 'patron_saint')}
                            </span>
                        )}
                        {fullname}
                    </span>
                </div>
                {children}
                <div className="absolute top-8 right-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            </div>
        </div>
    )
}

// 3 cột "bảng" theo yêu cầu: Học viên (tên + định danh) | Mã học viên | Tổ/Nhóm/Đội. grid-template-
// columns đặt qua INLINE STYLE (không dùng class Tailwind "grid-cols-[minmax(0,1fr)_150px_180px]")
// vì bản Tailwind JIT của app KHÔNG build ra class arbitrary có dấu phẩy lồng bên trong
// (minmax(0,1fr)) - thực tế đã thấy grid co lại theo nội dung, mất hẳn layout 3 cột. Style vô hại
// khi display là flex (mobile) - chỉ có tác dụng lúc sm:grid bật lên. Header (CourseClassStudentForm.js)
// PHẢI dùng chung STUDENT_TABLE_GRID_STYLE này để không lệch cột.
export const STUDENT_TABLE_GRID_STYLE = {gridTemplateColumns: 'minmax(0,1fr) 150px 180px'}
export const STUDENT_TABLE_GRID_CLASS = 'sm:grid sm:items-center sm:gap-3'

export const renderCourseClassStudent = ({translate: t, detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        student,
        medal_awards = [],
        sub_class_name,
        role_code,
    } = item ?? {}
    const {avatar, user, student_idcode, identifier_code, fullname, contact_email, contact_phone} = student ?? {}

    const groupColor = getGroupColor(sub_class_name)

    return (
        <div
            key={index}
            // Bảng 3 cột trên sm+ (grid) - dưới sm tự chuyển flex-col, MỖI CỘT xuống 1 dòng riêng
            // (nhãn nhỏ dẫn trước vì header cột đã ẩn) - 1 khối JSX duy nhất, không tách bản mobile
            // riêng như yêu cầu ("khỏi tách bảng").
            style={STUDENT_TABLE_GRID_STYLE}
            className={`p-3 sm:px-4 sm:py-2.5 flex flex-col gap-2 ${STUDENT_TABLE_GRID_CLASS} custom-item-render relative list-item`}>

            {/* Cột 1: Học viên - avatar + tên + định danh (identifier_code, CCCD/CMND...) */}
            <div className="flex items-center gap-3 min-w-0">
                <Avatar
                    size={36}
                    src={avatar || user?.avatar}
                    icon={<FaUserGraduate size={16} className="text-color-500"/>}
                    className="flex flex-center background-200 flex-shrink-0"
                />
                <div className="flex flex-col min-w-0">
                    <span className="font-bold text-sm text-color-000 leading-snug truncate">
                        {student?.patron_saint_name && (
                            <span className="mr-1 font-medium text-color-300">
                                {getAliasName(student, 'patron_saint')}
                            </span>
                        )}
                        {fullname}
                    </span>
                    {renderIf(
                        identifier_code,
                        <span
                            onClick={() => { copyToClipboard(identifier_code); message.info(t('copied')) }}
                            className="mt-0.5 font-mono text-xs text-color-400 hover:text-color-200 cursor-pointer flex items-center gap-1 whitespace-no-wrap w-fit">
                            <FaAddressCard size={10} className="flex-shrink-0"/>
                            {identifier_code}
                            <IoCopyOutline size={10}/>
                        </span>
                    )}
                    {/* Email/SĐT - hiện thêm để phân biệt học viên TRÙNG TÊN (bạn yêu cầu) - field
                        thật (StudentTransformerBasic.contact_email/contact_phone, nest qua
                        CourseClassStudentTransformer), ẩn hẳn dòng nếu học viên chưa có, không bịa
                        placeholder "chưa cập nhật" cho 2 field phụ này. */}
                    {(contact_phone || contact_email) && (
                        <div className="mt-0.5 flex flex-col gap-0.5">
                            {contact_phone && (
                                <span className="text-2xs text-color-400 flex items-center gap-1 whitespace-no-wrap w-fit truncate">
                                    <MdOutlinePhone size={11} className="flex-shrink-0"/>
                                    {contact_phone}
                                </span>
                            )}
                            {contact_email && (
                                <span className="text-2xs text-color-400 flex items-center gap-1 whitespace-no-wrap w-fit truncate">
                                    <MdOutlineEmail size={11} className="flex-shrink-0"/>
                                    {contact_email}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Cột 2: Mã học viên - nhãn CHỈ hiện dưới sm (ở sm+ header cột đã thay cho nhãn) */}
            <div className="pl-12 sm:pl-0 flex items-center gap-1.5">
                <span className="sm:hidden text-2xs text-color-400 uppercase tracking-wide">
                    {`${t('student code')} :`}
                </span>
                {renderIfElse(
                    student_idcode,
                    <span
                        onClick={() => { copyToClipboard(student_idcode); message.info(t('copied')) }}
                        className="font-mono text-xs text-blue-500 hover:text-blue-700 cursor-pointer whitespace-no-wrap flex items-center gap-1">
                        #{student_idcode}
                        <IoCopyOutline size={10}/>
                    </span>,
                    <span className="text-xs text-color-300 italic">{t('not update')}</span>
                )}
            </div>

            {/* Cột 3: Tổ/Nhóm/Đội - kèm vai trò (tổ trưởng...) và huy hiệu nếu có */}
            <div className="pl-12 sm:pl-0 flex flex-wrap items-center gap-1.5">
                <span className="sm:hidden text-2xs text-color-400 uppercase tracking-wide">
                    {`${t('class group')} :`}
                </span>
                {renderIfElse(
                    sub_class_name,
                    <span
                        style={{backgroundColor: groupColor + '1a', color: groupColor}}
                        className="px-2 py-0.5 rounded-full text-xs font-semibold whitespace-no-wrap">
                        {sub_class_name}
                    </span>,
                    <span className="text-xs text-color-300 italic">{t('not update')}</span>
                )}
                {role_code !== 'student' && (
                    <span className="px-2 py-0.5 rounded-full text-xs font-semibold text-indigo-600 background-100 whitespace-no-wrap">
                        {t(role_code)}
                    </span>
                )}
                {medal_awards.map((e, i) => (
                    <span key={i} className="text-xs font-bold text-primary whitespace-no-wrap">
                        {getTitle(e.medal)}
                    </span>
                ))}
                {renderActions(item)}
            </div>

            {renderIf(
                item?.course_class?.edit,
                <div className="sm:col-span-3">
                    {renderMetadataMissing(_.get(item, 'metadata', []))}
                </div>
            )}
            <div className="absolute top-3 right-3 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

export const renderCourseClassStudentSimple = ({translate: t}) => (item, index) => {
    const {student, sub_class_name, role_code} = item ?? {}
    const {fullname, student_idcode, patron_saint_name} = student ?? {}

    const groupColor = getGroupColor(sub_class_name)
    const initial = getNameInitial(fullname)


    return (
        <div
            key={index}
            className="px-3 py-2 flex items-center gap-3 background hover:background-50 transition-all duration-300">
            <div
                style={{width: 32, height: 32, backgroundColor: groupColor, flexShrink: 0}}
                className="rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm leading-none">{initial}</span>
            </div>
            <div className="flex flex-col flex-1">
                <span className="font-semibold text-sm text-color-000 leading-snug truncate">
                    {patron_saint_name && (
                        <span className="mr-1 font-medium text-gray-600">
                            {getAliasName(student, 'patron_saint')}
                        </span>
                    )}
                    {fullname}
                </span>
                {role_code === "student_leader" ? (
                    <span className="font-medium text-2xs text-secondary-500 italic tracking-wider">
                        {t('student_leader')}
                    </span>
                ) : null}
            </div>
            <div style={{minWidth: 115}} className="flex justify-center flex-shrink-0">
                {sub_class_name && (
                    <span
                        style={{
                            backgroundColor: groupColor + '20',
                            color: groupColor,
                            padding: '1px 8px',
                        }}
                        className="text-xs font-semibold rounded-full whitespace-no-wrap">
                        {sub_class_name}
                    </span>
                )}
            </div>
            <span style={{minWidth: 110}} className="font-mono text-xs text-blue-500 text-right whitespace-no-wrap flex-shrink-0">
                {student_idcode}
            </span>
        </div>
    )
}

export const renderCourseClassStudentWithSubject = ({renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        student,
        result_status,
        registered_subjects = [],
    } = item ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <Translate>
            {(t) => (
                <WrapperClassStudent item={item} index={index} renderContextMenu={renderContextMenu}>
                    <div className="ml-3 flex flex-col flex-1">
                        <div className="flex items-baseline gap-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500 whitespace-no-wrap italic">
                                {`${t('subjects registered')} :`}
                            </span>
                            {renderIfElse(
                                registered_subjects.length > 0,
                                registered_subjects.map((e, i) => (
                                    <span className="font-semibold text-color-100">
                                        {e?.title} {i < registered_subjects.length - 1 && ', '}
                                    </span>
                                )),
                                <span className="font-medium text-color-300">
                                    {t('not update')}
                                </span>
                            )}
                        </div>
                    </div>
                </WrapperClassStudent>
            )}
        </Translate>
    )
}

export const renderStudentCard = ({course_class, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {course, owner} = course_class ?? {}
    const myDivRef = useRef(null);
    const [saved, setSaved] = useState(false)

    const {
        student,
    } = item ?? {}

    const {
        avatar,
        edit,
        user,
        patron_saint_name,
        student_idcode,
        prefix_title,
        fullname,
    } = student ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div className="border border-color-50 background hover:shadow-md hover:scale-102 rounded-xl custom-student-card relative transition-all duration-300">
                    <div ref={myDivRef} //style={{maxWidth: 280}}
                         className="h-full flex flex-col">
                        <div className="px-1 py-2 flex flex-col items-center border-b border-color-50">
                            <span style={{marginBottom: 3, fontSize: 11}}
                                  className="text-center font-bold text-green-500 italic tracking-wide leading-tight">
                                {_.get(owner, 'diocese.fullname') || _.get(owner, 'title') || `${t('diocese')} ...`}
                            </span>
                            {renderIf(
                                _.get(owner, 'parish'),
                                // <ResponsiveTextLabel
                                //     style={{minHeight: 'unset'}}
                                //     defaultFontSize={18}
                                //     minFontSize={13}
                                //     maxFontSize={19}
                                //     showIcon={false}
                                //     text={_.get(owner, 'parish.fullname') || `${t('parish')} ...`}
                                //     className="text-center font-extrabold text-blue-700 uppercase tracking-widest leading-snug"
                                // />
                                <span className="text-center font-bold text-lg text-blue-700 uppercase tracking-widest leading-snug">
                                    {owner?.parish?.fullname}
                                </span>
                            )}
                        </div>
                        <div className="px-2 py-2 md:py-4 my-auto flex flex-col items-center gap-2">
                            <QRComponent
                                key={index}
                                visible={true}
                                defaultMaxSize={140}
                                id={"student|" + student?.id}
                                encode={getAbsoluteLinkToDetail(student)}
                            />
                            <div className="flex flex-col flex-center flex-1 my-1">
                                {renderIf(
                                    patron_saint_name,
                                    <span style={{fontSize: 14}}
                                          className="text-center font-medium text-primary tracking-widest leading-tight">
                                        {getAliasName(student, 'patron_saint')}
                                    </span>
                                )}
                                <span
                                    style={{fontSize: 16, padding: '2px 0'}}
                                    className="text-center font-extrabold text-primary tracking-wider leading-tight">
                                    {fullname}
                                </span>
                                <span
                                    className="font-medium text-2xs text-color-400 italic tracking-wider leading-tight">
                                    {`#${student_idcode}`}
                                </span>
                            </div>
                            <div style={{fontSize: 14}}
                                 className="text-center font-bold text-color-000 tracking-wide leading-tight">
                                {`${t('classes')} ${getTitle(course_class)}`}
                            </div>
                        </div>
                        <div className="px-1 py-2 border-t border-color-50 flex flex-col">
                                    <span
                                        className="text-center space-x-1 font-bold text-xs text-color-100 leading-snug max-lines-1">
                                        {getTitle(course_class?.course)}
                                    </span>
                            <span style={{marginTop: 2}}
                                  className="text-center font-medium text-2xs text-color-300 italic tracking-wide leading-tight">
                                        {renderFromToDate(course?.time_open, course?.time_close)}
                                    </span>
                        </div>
                    </div>
                    <div
                        style={{
                            height: 80,
                            background: 'linear-gradient(to top, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 / 70%) 10%, rgb(0 0 0 / 30%) 30%, rgba(255, 255, 255, 0) 70%)',
                        }}
                        className="w-full p-2 flex items-end justify-center button-download absolute bottom-0 rounded-b-lg">
                        {renderIfElse(
                            saved,
                            <span className="italic text-xs text-primary-200">{t('saved')}</span>,
                            <div
                                onClick={() => {
                                    if (myDivRef && myDivRef.current) {
                                        captureImage(
                                            myDivRef.current,
                                            (blob) => {
                                                // Tạo một URL tạm thời từ blob
                                                var url = URL.createObjectURL(blob);

                                                // Tạo một thẻ a ẩn để tải ảnh xuống
                                                var a = document.createElement('a');
                                                a.style.display = 'none';
                                                a.href = url;
                                                a.download = student_idcode + '-' + fullname + '-qr.png'; // Tên tệp bạn muốn lưu

                                                // Gắn thẻ a vào document và kích hoạt sự kiện click để tải tệp
                                                document.body.appendChild(a);
                                                a.click();

                                                // Hủy URL sau khi tải xong để giải phóng bộ nhớ
                                                URL.revokeObjectURL(url);

                                                setSaved(true)
                                                // setTimeout(() => {
                                                //     setSaved(false)
                                                // }, 15000)
                                            }
                                        )
                                    }
                                }}
                                className="flex flex-center gap-x-2 text-white cursor-pointer">
                                <PiDownloadFill size={16}/>
                                <span className="font-bold text-xs italic">
                                            {t('download')}
                                        </span>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}